<script>
  import emailjs from 'emailjs-com'
  emailjs.init('7Ti8j60qJGDVhr1Xn')
  export default {
    name: 'Contact',
    data() {
      return {
        formData: {
          name: '',
          tel: '',
          email: '',
          location: '',
          dateForBusiness: '',
          locationForBusiness: '',
          countryForBusiness: '',
          franchiseManagement: '',
          franchiseManagementDescription: '',
          whatFranchise: '',
          investmentAmount: '',
          ownPremises: '',
          meetFranchise: '',
          meetFranchiseOther: '',
          comments: ''          
        },
        sendRequest: false
      }
    },
    methods: {
      sendEmail() {
        this.sendRequest = true
        /*emailjs.send('service_ahqyxds', 'template_ugjrswi', this.formData).then(
          (result) => {
            console.log('SUCCESS!', result.text)
            this.sendRequest = true
          },
          (error) => {
            console.log('FAILED...', error.text)
          }
        ) */
      },
    },
  }
</script>

<template>
  <!-- CONTACT FORM START-->
  <section class="section" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">CONTÁCTANOS</h1>
          <div class="section-title-border margin-t-20"></div>
          <h3 class="section-subtitle text-muted text-center font-secondary padding-t-30"
            >Invierte 5 minutos en nuestro formulario y recibe información de nuestra franquicia exitosa
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="custom-form mt-4 pt-4">
            <div id="message"></div>
            <form method="post" name="contact-form" id="contact-form" ref="contactForm">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      required
                      v-model="formData.name"
                      class="form-control"
                      placeholder="Nombre y Apellido*"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="tel"
                      id="tel"
                      type="tel"
                      required
                      v-model="formData.phone"
                      class="form-control"
                      placeholder="Teléfono celular*"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="email"
                      id="email"
                      type="email"
                      required
                      v-model="formData.email"
                      class="form-control"
                      placeholder="Correo electrónico*"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <input
                      name="name"
                      id="name"
                      type="text"
                      required
                      v-model="formData.location"
                      class="form-control"
                      placeholder="Localidad de residencia*"
                    />
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <label for="countryForBusiness"
                      >¿En qué pais pretende abrir el negocio?*
                      <input
                        name="countryForBusiness"
                        id="countryForBusiness"
                        type="text"
                        required
                        v-model="formData.countryForBusiness"
                        class="form-control"
                        placeholder="Pais"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <label for="locationForBusiness"
                      >¿En qué zona pretende abrir el negocio?*
                      <input
                        name="locationForBusiness"
                        id="locationForBusiness"
                        type="text"
                        required
                        v-model="formData.locationForBusiness"
                        class="form-control"
                        placeholder="Dirección"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <label for="date">
                      ¿Para qué fecha piensa tener su negocio?*
                      <input
                        name="date"
                        id="date"
                        type="date"
                        required
                        v-model="formData.dateForBusiness"
                        class="form-control"
                        placeholder="¿Para qué fecha piensa tener su negocio?*"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="row no-gutters form-group mt-2">
                    <p class="col m-0 label"> ¿Maneja o manejó alguna franquicia?* </p>

                    <label for="manageTrue" class="col-2 m-0">
                      <input
                        name="manageTrue"
                        id="manageTrue"
                        type="radio"
                        value="Si"
                        required
                        v-model="formData.franchiseManagement"
                      />Si
                    </label>
                    <label for="manageFalse" class="col-2 m-0">
                      <input
                        name="manageFalse"
                        id="manageFalse"
                        type="radio"
                        value="No"
                        required
                        v-model="formData.franchiseManagement"
                      />
                      No
                    </label>
                  </div>
                  <div class="row no-gutters form-group mt-2">
                    <p class="col m-0 label align-self-center">En caso que si, ¿Cúal?</p>
                    <input
                      name="manageDescription"
                      id="manageDescription"
                      type="text"
                      required
                      class="col form-control m-0"
                      v-model="formData.franchiseManagementDescription"
                    />
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mt-2">
                    <label for="investment"
                      >¿Qué monto pretende invertir?
                      <input
                        name="investment"
                        id="investment"
                        type="text"
                        v-model="formData.investmentAmount"
                        class="form-control"
                        placeholder="(Expresado en USD)"
                      />
                    </label>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="row no-gutters form-group mt-2">
                    <p class="col m-0 label"
                      >¿Cuenta con local propio o piensa alquilar?</p
                    >
                    <label for="premisesTrue" class="col-2 m-0">
                      <input
                        name="premisesTrue"
                        id="premisesTrue"
                        type="radio"
                        value="Si"
                        required
                        v-model="formData.ownPremises"
                      />Si
                    </label>
                    <label for="premisesFalse" class="col-2 m-0">
                      <input
                        name="premisesFalse"
                        id="premisesFalse"
                        type="radio"
                        value="No"
                        required
                        v-model="formData.ownPremises"
                      />
                      No
                    </label>
                  </div>
                  <div class="row no-gutters form-group mt-2">
                    <p class="col m-0 label align-self-center"
                      >Si es alquilar, ¿En qué zona?</p
                    >
                    <input
                      name="manageDescription"
                      id="manageDescription"
                      type="text"
                      required
                      class="col form-control m-0"
                      v-model="formData.whatFranchise"
                    />
                  </div>
                </div>
                <div class="row form-group m-0 w-100">
                  <div class="col-lg-6">
                    <input
                      list="know"
                      name="myBrowser"
                      v-model="formData.meetFranchise"
                      class="form-control"
                      placeholder="¿Cómo se enteró de la franquicia?"
                    />
                    <datalist id="know">
                      <option value="Facebook"> </option
                      ><option value="Linkedin"> </option
                      ><option value="Web empresa"> </option
                      ><option value="Referido"> </option><option value="Portal"> </option
                      ><option value="Soy Cliente"> </option
                      ><option value="Otro"> </option
                    ></datalist>
                  </div>
                  <div class="col-lg-6">
                    <input
                      name="meetFranchiseOther"
                      id="meetFranchiseOther"
                      type="text"
                      class="form-control"
                      v-model="formData.meetFranchiseOther"
                      placeholder="En caso de: Otro. Especifique"
                    />
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="form-group mt-2">
                    <textarea
                      name="comments"
                      id="comments"
                      v-model="formData.comments"
                      rows="4"
                      class="form-control"
                      placeholder="Tu mensaje..."
                    ></textarea>
                  </div>
                </div>
                <div class="row w-100 justify-content-end">
                  <div class="col-lg-12 text-right">
                    <input
                      type="submit"
                      id="submit"
                      name="send"
                      @click.prevent="sendEmail()"
                      class="submitBnt btn btn-custom"
                      value="Enviar Mensaje"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div v-if="sendRequest == true">
            <h5 class="section-subtitle text-muted text-center font-secondary padding-t-30">
              <strong>SOLICITUD DE FRANQUICIA  RECIBIDA</strong> 
            </h5>
            <h6 class="section-subtitle text-muted text-center font-secondary padding-t-30">
              Gracias por tu interés en la FRANQUICIA DIU nos estaremos comunicando con usted en las próximas horas
            </h6>
          </div>
          
        </div>
      </div>
    </div>
  </section>
  <!-- CONTACT FORM END-->
</template>

<style scoped>
  hr {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    border: 0;
    border-top: 5px solid rgba(0, 0, 0, 0.2);
  }
  label {
    width: 100%;
  }
  .label {
    font-size: 1rem;
  }
</style>
